import { useIntl } from 'react-intl';
import { useStyles } from 'uinix-ui';

import { LOGIN_CONSTANTS } from '~/common/constants/login';
import { Button } from '~/eds/src/components/Button/Button';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { Logo } from '~/eds/src/components/Logo/Logo';
import { Text } from '~/eds/src/components/Text/Text';
import { useCountdown } from '~/hooks/useCountdown';

const Page = () => {
  const styles = useStyles();
  const intl = useIntl();

  const handleClose = () => {
    window.close();
    // should always be called from a popup + iframe (but guarding with ?. in scenarios this is not the case)
    window?.opener?.top?.postMessage(
      {
        type: LOGIN_CONSTANTS.EVENTS.LOGIN_EMBED_SUCCESS,
      },
      '*',
    );
  };

  const countdown = useCountdown(
    5,
    (countdown) => countdown === 0 && handleClose(),
  );

  return (
    <Layout
      align="center"
      justify="center"
      styles={styles.background.darkChrome}
    >
      <Layout align="center" preset="sections">
        <Logo mode="icon" theme="dark" />
        <Text color="inherit" textAlign="center" variant="title">
          {intl.formatMessage({
            id: 'LoginEmbedSuccessPage.successTitle',
            defaultMessage: 'You have successfully logged in',
            description: 'Success message title for embedded login',
          })}
        </Text>
        {countdown > 0 && (
          <Text color="inherit" textAlign="center">
            {intl.formatMessage(
              {
                id: 'LoginEmbedSuccessPage.autoCloseMessage',
                defaultMessage:
                  'This window will automatically close in {countdown} seconds',
                description:
                  'Message showing countdown before auto-close. Example: countdown = "5"',
              },
              { countdown },
            )}
          </Text>
        )}
        <Button
          isFullWidth
          text={intl.formatMessage({
            id: 'LoginEmbedSuccessPage.closeButton',
            defaultMessage: 'Close',
            description: 'Close button text',
          })}
          onClick={handleClose}
        />
      </Layout>
    </Layout>
  );
};

export default Page;
